import  _ from 'lodash';
import { RestService } from '../lib';



/**
 * Service Endpoint Implementation
 */
export default class AppRestService extends RestService {

  constructor(opts = null) {
    super(opts);
    this.idParamName = 'id';
  }

  getDefaultQueryParams(id) {
    let params = null;
    if (this.idParamName) {
      params = _.set({}, this.idParamName, id);
    }
    return params;
  }

  // returns a single resource item
  async get(id, queryParams = null, opts = null) {
    queryParams = _.extend(queryParams || {}, this.getDefaultQueryParams(id));
    return super.get('read', queryParams, opts);
  }

  // creates a new DB resource items. a new id will be created by the API.
  async create(postParams = null, queryParams = null, opts = null) {
    let path = [this.routePath, 'create'];
    opts = this._getDefaultRequestOpts(opts);
    let res = await this.request.post(path, postParams, queryParams, opts);
    res = this._populateResponseModel(res);
    return res;
  }

  // update will replace all DB resource fields.
  // If fields are missing from the update request, they may get deleted from the DB resource.
  async update(id, postParams = null, queryParams = null, opts = null) {
    queryParams = _.extend(queryParams || {}, this.getDefaultQueryParams(id));
    return super.update('update', postParams, queryParams, opts);
  }

  // mark a resource item as deleted.
  // Depending on the service endpoint, this may mark an item as deleted or purge the item.
  async remove(id, queryParams = null, opts = null) {
    if (!id) { return this.request.reject('invalid id'); }
    queryParams = _.extend(queryParams || {}, this.getDefaultQueryParams(id));
    let path = [this.routePath, 'delete'];
    opts = this._getDefaultRequestOpts(opts);
    let res = await this.request.delete(path, queryParams, opts);
    res = this._populateResponseModel(res);
    return res;
  }

}

